import React from 'react'

export const BackSvg = () => (
  <svg
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="2727"
    width="128"
    height="128"
  >
    <path
      d="M645.184 300.358 123.27 300.358 305.708 117.92l-21.881-21.896L86.881 292.984 65 314.865l21.881 21.882 196.946 196.945 21.881-21.881L124.72 330.823l520.464 0c156.235 0 283.352 127.102 283.352 283.337 0 156.236-127.116 283.353-283.352 283.353L472.93 897.513c-4.065 0-7.888 1.587-10.76 4.458-2.886 2.886-4.473 6.709-4.473 10.774 0 4.064 1.587 7.888 4.488 10.789 2.856 2.856 6.679 4.442 10.744 4.442l172.254 0C818.223 927.977 959 787.2 959 614.16 959 441.136 818.223 300.358 645.184 300.358z"
      p-id="2728"
    ></path>
  </svg>
)

export const NextSvg = () => (
  <svg
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="3539"
    width="128"
    height="128"
  >
    <path
      d="M378.816 300.358 900.73 300.358 718.292 117.92l21.881-21.896 196.946 196.961L959 314.865l-21.881 21.882L740.173 533.692l-21.881-21.881L899.28 330.823 378.816 330.823c-156.235 0-283.352 127.102-283.352 283.337 0 156.236 127.116 283.353 283.352 283.353L551.07 897.513c4.065 0 7.888 1.587 10.76 4.458 2.886 2.886 4.473 6.709 4.473 10.774 0 4.064-1.587 7.888-4.488 10.789-2.856 2.856-6.679 4.442-10.744 4.442L378.816 927.976C205.777 927.977 65 787.2 65 614.16 65 441.136 205.777 300.358 378.816 300.358z"
      p-id="3540"
    ></path>
  </svg>
)
